import { customElement } from 'lit/decorators.js';
import { componentStateStore } from '@src/store';

import { TefComsCancelButton } from './TefComsCancelButton';

@customElement('tef-coms-back-button')
export class TefComsBackButton extends TefComsCancelButton {
  variant: string = 'outline';

  handleClick() {
    componentStateStore.disabled = true;

    this.triggerEvent({
      name: 'action/CANCEL_MICROFRONTEND',
      level: 'info',
      message: 'cancel action invoked',
    });
  }
}
